import React from "react";
import { ITextArea } from "types/gaiaComponents/textarea";

export const TextArea = React.forwardRef<HTMLTextAreaElement, ITextArea>((props, ref) => {
    return (
        <textarea className={`ga-text-area${props.isInvalid ? " ga-text-area--invalid" : ""}`}
                  id={props.id}
                  data-testid={props.id}
                  maxLength={props.maxLength}
                  ref={ref}
                  rows={5}
                  placeholder={props.placeholder}
                  disabled={props.isDisabled}
                  tabIndex={props.tabIndex}
                  value={props.value}
                  onChange={props.onChange}
        ></textarea>
    )
});
